import { Input, Segmented } from 'antd'
import {
  SIGNATURE_INK,
  TYPED_SIGNATURE_FONTS,
  TypedSignatureFont,
} from 'pages/reporting/shared/eSignature/utils/typedSignature'
import { FC } from 'react'
import styled from 'styled-components'

const Preview = styled.div<{ $family: string }>`
  min-height: 5rem;
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 1px solid ${(props) => props.theme.forecast.border};
  border-radius: 0.5rem;
  background: white;
  color: ${SIGNATURE_INK};
  font-family: '${(props) => props.$family}', cursive;
  font-size: 2.5rem;
  white-space: nowrap;
  overflow: hidden;
`

const FONT_OPTIONS = TYPED_SIGNATURE_FONTS.map((font) => ({
  label: font.label,
  value: font.id,
}))

interface TypedSignatureFieldsProps {
  text: string
  font: TypedSignatureFont
  onTextChange: (text: string) => void
  onFontChange: (fontId: string) => void
}

/** Name entry, script-style picker, and live preview for a typed signature. */
export const TypedSignatureFields: FC<TypedSignatureFieldsProps> = ({
  text,
  font,
  onTextChange,
  onFontChange,
}) => (
  <>
    <Input
      aria-label='Signature text'
      maxLength={60}
      value={text}
      onChange={(e) => onTextChange(e.target.value)}
    />
    <Segmented<string>
      options={FONT_OPTIONS}
      value={font.id}
      onChange={onFontChange}
    />
    <Preview $family={font.family}>{text.trim()}</Preview>
  </>
)
